import React, { createContext, useReducer } from 'react';
import * as PropTypes from 'prop-types';
import jwt from 'jsonwebtoken';
import EnrollmentReducer from './enrollmentReducer';
import steps from '../../domain/EnrollmentPage/steps';
import stepsEnrollmentLegal from '../../domain/EnrollmentLegal/steps';

// COMENTARIO

const initialContextState = {
  enrollmentForm: {
    contact: {},
    step1: {},
    step2: {},
    step3: {},
  },
  currentStepIndex: 0,
  currentStepEnrollmentLegalIndex: 0,
  currentStep: steps[0],
  currentStepEnrollmentLegal: stepsEnrollmentLegal[0],
  trackingNumber: 0,
  currentView: '',
  figureType: '',
  areLegalBackgroundInstructionRead: false,
  areUafInstructionsRead: false,
  enrollmentId: 0,
  enrollment: {},
};

export const EnrollmentContext = createContext({ ...initialContextState, dispatch: () => {} });

const initializeState = (initialState) => {
  const postulantEmail = sessionStorage.getItem('postulant-email');
  const postulantRut = sessionStorage.getItem('postulant-rut');
  const token = sessionStorage.getItem('vantrust.token');

  const { id, figureType } = token ? jwt.decode(token) : {};

  return {
    ...initialState,
    figureType,
    enrollmentId: id,
    postulantEmail,
    postulantRut,
  };
};

const EnrollmentProvider = ({ children }) => {
  const [state, dispatch] = useReducer(EnrollmentReducer, initialContextState, initializeState);

  const contextValue = { ...state, dispatch };

  return <EnrollmentContext.Provider value={contextValue}>{children}</EnrollmentContext.Provider>;
};

EnrollmentProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export default EnrollmentProvider;
